<template>
  <tr
    class="clickable"
    @click="goToYacht(yacht.id)"
  >
    <td>
      <strong>{{ yacht.id }}</strong>
    </td>
    <td>
      <div
        v-if="!yacht.name"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.name }}
      </div>
      <div
        v-if="view === 'active' && (!yacht.nausys_ids || yacht.nausys_ids.length === 0)"
        class="error--text caption"
      >
        NauSys ID: Unknown
      </div>
      <div
        v-else-if="view === 'active'"
        class="caption grey--text"
      >
        NauSys ID: {{ yacht.nausys_ids.join(', ') }}
      </div>
    </td>
    <td>
      <div
        v-if="!yacht.hull_number"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.hull_number }}
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        style="max-width: 110px"
        class="text-truncate"
      >
        <flag
          :iso="yacht.country.code"
          class="mr-1"
          :squared="false"
        />
        <span v-if="view === 'active'">
          {{ yacht.current_base ? yacht.current_base.name : 'N/A' }}
        </span>
        <span v-else>
          {{ yacht.destination_base ? yacht.destination_base.name : 'N/A' }}
        </span>
      </div>
    </td>
    <td v-if="view === 'incoming'">
      <div
        v-if="!yacht.final_delivery"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.final_delivery_estimated_end_at | moment('D MMM YYYY') }}<br>
      </div>
    </td>
    <td v-if="view === 'arrived'">
      <div
        v-if="!charterStartDate"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ charterStartDate | moment('D MMM YYYY') }}<br>
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        style="max-width: 200px; text-overflow: ellipsis; overflow: hidden"
      >
        {{ yacht.model.label }}
        <div class="font-weight-light grey--text text--darken-2">
          {{ yacht.model.manufacturer.name }} &middot; #{{ yacht.model.id }}
        </div>
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        v-if="!yacht.flag_country"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div
        v-else
      >
        <flag
          :iso="yacht.flag_country.code"
          :squared="false"
        />
      </div>
    </td>
    <td v-if="view === 'active'">
      <div
        v-if="!yacht.current_engine_hours || yacht.current_engine_hours.length === 0"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        <v-chip
          v-for="(engine, index) in yacht.current_engine_hours"
          :key="'engine_'+engine.yacht_engine_id+index"
          outlined
          small
        >
          {{ engine.hours }} h
        </v-chip>
      </div>
    </td>
    <td>
      <span v-if="yacht.finance_model">{{ yacht.finance_model.label }}</span>
      <span
        v-else
        class="grey--text"
      >
        N/A
      </span>
    </td>
    <td v-if="view === 'incoming' || view === 'arrived'">
      <span
        v-if="!yacht.nausys_ids || yacht.nausys_ids.length === 0"
        class="error--text"
      >
        <v-icon
          x-small
          color="error"
        >
          fa fa-times
        </v-icon>
        Not Provided
      </span>
      <span
        v-else
      >
        <v-icon
          x-small
          color="success"
        >
          fa fa-check
        </v-icon>
        {{ yacht.nausys_ids.join(', ') }}
      </span>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'YachtRow',
    props: {
      yacht: {
        type: Object,
        default: null
      },
      view: {
        type: String,
        default: 'active'
      }
    },
    computed: {
      charterStartDate() {
        if (!this.yacht.delivery_steps || this.yacht.delivery_steps.length === 0) return null

        const charterStart = this.yacht.delivery_steps.find(d => d.type === 'charter_start')

        if (!charterStart) return null

        return charterStart.estimated_at
      }
    },
    methods: {
      goToYacht(id) {
        let route = this.$router.resolve({ name: 'yachtDashboard', params: { id: id } })

        window.open(route.href, '_blank')
      }
    }
  }
</script>
